/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'

//
import ButtonNew from '../ButtonNew'

const MultiFilterActiveFilters = ({
  items = [],
  clearLabel,
  handleClose = () => {},
  handleClear = () => {}
}) => {
  if (!items?.length) {
    return null
  }

  const handleClearClick = (e) => {
    e.preventDefault()
    handleClear()
  }

  return (
    <div className="c-multi-filter-filters">
      {items.map((item) => (
        <ButtonNew
          key={`filter-${item.gid}-${item.label}`}
          filter
          icon="ti-close"
          onClick={() => handleClose(item.gid, item.label)}
        >
          {item.label}
        </ButtonNew>
      ))}

      <div className="c-multi-filter-filters__clear">
        <a href="#" onClick={handleClearClick} rel="noreferrer norel">
          {clearLabel}
        </a>
      </div>
    </div>
  )
}

export default MultiFilterActiveFilters
